import React from 'react'
import PropTypes from "prop-types"
import {Input, Label, Modal, ModalBody, ModalHeader} from 'reactstrap';
import {copyToClipboard} from "../../helpers/component_helpers";


const TokenModal = props => {
  const {isOpen, toggle, token} = props;

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      role="dialog"
      autoFocus={true}
      centered={true}
      className="exampleModal"
      tabIndex="-1"
    >
      <div className="modal-content">
        <ModalHeader toggle={toggle}>
          Authentication Token
        </ModalHeader>
        <ModalBody>
          <span className="font-size-12">
            <span className="text-warning">Note: </span>
            This token won’t be stored. Copy or save it before closing the modal.
          </span>
          <div className="mt-2">
            <Label htmlFor="token mb-1">
              Token
            </Label>
            <div className="d-flex">
              <Input
                id="token"
                name="token"
                type="text"
                readOnly={true}
                value={token}
              />
              <i className="bx bx-copy-alt mx-1 my-2" style={{
                textAlign: 'center',
                verticalAlign: 'middle',
                fontSize: 'large',
                cursor: 'pointer',
              }} onClick={() => {
                copyToClipboard(token)
              }}></i>
            </div>
          </div>
        </ModalBody>
      </div>
    </Modal>
  )
}

TokenModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  token: PropTypes.string,
}

export default TokenModal
